import { builderCopy as copy, fill } from "./copy";

/**
 * The builder's in-place "Remove “…”?" (KEY-560): nothing is removed until the author presses Remove a second time. Anything
 * else that goes with it is said underneath, one line each.
 */
export function ConfirmRemove({
  name,
  consequences,
  onKeep,
  onRemove,
}: {
  name: string;
  consequences?: readonly string[];
  onKeep: () => void;
  onRemove: () => void;
}) {
  const question = fill(copy.build.removeConfirm, { name: name || copy.build.untitled });
  return (
    <div className="kd-panel-confirm" role="group" aria-label={question}>
      <span>{question}</span>
      {consequences && consequences.length > 0 && (
        <ul className="kd-panel-confirm-lines">
          {consequences.map((line) => (
            <li key={line}>{line}</li>
          ))}
        </ul>
      )}
      <button type="button" className="kd-btn" onClick={onKeep}>
        {copy.build.keepIt}
      </button>
      <button type="button" className="kd-btn-primary" onClick={onRemove}>
        {copy.build.remove}
      </button>
    </div>
  );
}
